"use client"

import Script from "next/script"
import { Card, CardContent } from "@/components/ui/card"
import { MapPin, Shield } from "lucide-react"

export function ServiceAreaSection() {
  const areas = [
    {
      name: "Downtown San Diego",
      description: "Financial District, Gaslamp, Little Italy",
      color: "from-primary/20 to-primary/5",
    },
    {
      name: "La Jolla",
      description: "UTC, Golden Triangle, Torrey Pines",
      color: "from-blue-200/50 to-blue-100/20",
    },
    {
      name: "North County Coastal",
      description: "Carlsbad, Encinitas, Oceanside",
      color: "from-cyan-200/50 to-cyan-100/20",
    },
    {
      name: "North County Inland",
      description: "Escondido, San Marcos, Vista",
      color: "from-amber-200/50 to-amber-100/20",
    },
    {
      name: "East County",
      description: "El Cajon, Santee, La Mesa",
      color: "from-green-200/50 to-green-100/20",
    },
    {
      name: "South Bay",
      description: "Chula Vista, National City, Imperial Beach",
      color: "from-violet-200/50 to-violet-100/20",
    },
  ]

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/20 via-background to-accent/10" />
      <div className="absolute top-20 right-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-64 h-64 bg-accent/10 rounded-full blur-3xl" />

      <div className="container relative mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent/20 text-green-700 rounded-full text-sm font-medium mb-4">
            <MapPin className="h-4 w-4" />
            Coverage Area
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 text-balance">
            Serving All of San Diego County
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto text-pretty">
            HIPAA compliance services for healthcare providers throughout San Diego County.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Left Column - Service Areas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {areas.map((area, index) => (
              <Card key={index} className="border-0 shadow-md hover:shadow-lg transition-all hover:-translate-y-1 bg-white/80 backdrop-blur">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-3">
                    <div className={`inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br ${area.color} flex-shrink-0`}>
                      <MapPin className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-foreground mb-1">{area.name}</h3>
                      <p className="text-sm text-muted-foreground">{area.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Right Column - Contact Form */}
          <Card className="border-0 shadow-lg bg-white/90 backdrop-blur">
            <CardContent className="p-8">
              <div className="flex items-center gap-2 mb-4">
                <Shield className="h-6 w-6 text-primary" />
                <h3 className="text-xl font-bold text-foreground">Get in Touch</h3>
              </div>
              <p className="text-muted-foreground mb-6">
                Don't see your area? We serve all of San Diego County. Contact us to confirm coverage or request a free assessment.
              </p>

              {/* HubSpot Form */}
              <Script
                src="https://js.hsforms.net/forms/embed/47453230.js"
                strategy="afterInteractive"
              />
              <div
                className="hs-form-frame"
                data-region="na1"
                data-form-id="82cd6340-250d-4914-81d7-4d7797e8989b"
                data-portal-id="47453230"
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
